module.exports = __webpack_public_path__ + "img/productshop-header.0222f438.png";